import React from 'react';
import { Helmet } from 'react-helmet';
import { cn } from '../../utils/cn';

const PageLayout = ({
  children,
  title,
  description,
  keywords,
  className = '',
  backgroundClass = 'bg-background',
  includeHelmet = true,
  mainClassName = 'pt-16',
  ...props
}) => {
  return (
    <>
      {includeHelmet && (
        <Helmet>
          <title>{title}</title>
          {description && <meta name="description" content={description} />}
          {keywords && <meta name="keywords" content={keywords} />}
        </Helmet>
      )}
      
      <div className={cn('min-h-screen', backgroundClass, className)} {...props}>
        <main className={mainClassName}>
          {children}
        </main>
      </div>
    </>
  );
};

export default PageLayout;